/**
 * Authoritative trade-entry routes for persisted ticket types.
 *
 * New trades must route by ticketType before any legacy asset-class or
 * security-label heuristics are considered.
 */
export function getTradeEntryPathForTicketType(ticketType?: string | null): string | null {
  switch (String(ticketType || '').trim().toUpperCase()) {
    case 'ABF':
      return 'abf-facility';
    case 'LEVERAGED_LOAN':
      return 'leveraged-loan';
    case 'PRIVATE_CREDIT':
      return 'private-fixed-income';
    case 'CLO_TRANCHE':
      return 'clo-equity';
    case 'CMBS_TRANCHE':
      return 'cmbs-tranche';
    case 'RMBS_TRANCHE':
      return 'rmbs-tranche';
    case 'ABS_TRANCHE':
      return 'abs-tranche';
    case 'MSR':
      return 'msr';
    case 'PUBLIC_FI':
      return 'fixed-income';
    case 'RE':
      return 'real-estate';
    case 'RE_DEBT':
      return 'real-estate-debt';
    case 'PE_COMMITMENT':
      return 'private-equity';
    case 'PORTCO_DEBT':
      return 'portco-debt';
    case 'IRS':
      return 'derivatives/ir-swap';
    case 'TRS':
      return 'derivatives/tr-swap';
    case 'CCS':
      return 'derivatives/currency-swap';
    case 'CDS':
    case 'CDX':
      return 'derivatives/cd-swap';
    case 'SWAPTION':
      return 'derivatives/swaption';
    case 'FUTURES':
      return 'derivatives/futures';
    case 'OPTIONS':
      return 'derivatives/options';
    case 'FX':
      return 'fx/spot';
    case 'REPO':
      return 'repo';
    case 'CASH_TRANSFER':
      return 'cash';
    default:
      return null;
  }
}
